import {Injectable} from '@angular/core';
import {Matrix4, Object3D, PerspectiveCamera, Quaternion, Vector3} from 'three';

@Injectable({
    providedIn: 'root'
})
export class CameraService {
    public camera: PerspectiveCamera;

    // get/set
    private _canvasHeight: number;
    private _canvasWidth: number;
    private _rotateImage = true;

    // get
    private _viewOffsetX = 0;
    private _viewOffsetY = 0;
    private _defaultQuaternion: Quaternion;
    private _previousRotation = new Vector3();

    constructor() {
    }

    get canvasHeight(): number {
        return this._canvasHeight;
    }

    set canvasHeight(value: number) {
        this._canvasHeight = value;
    }

    get canvasWidth(): number {
        return this._canvasWidth;
    }

    set canvasWidth(value: number) {
        this._canvasWidth = value;
    }

    get previousRotation(): Vector3 {
        return this._previousRotation;
    }

    get rotateImage(): boolean {
        return this._rotateImage;
    }

    set rotateImage(value: boolean) {
        this._rotateImage = value;
    }

    get viewOffsetX(): number {
        return this._viewOffsetX;
    }

    get viewOffsetY(): number {
        return this._viewOffsetY;
    }

    get defaultQuaternion(): Quaternion {
        return this._defaultQuaternion;
    }

    // -------------------------------------------------------------------------------------------------------------------------------------

    /**
     * initialize new PerspectiveCamera with given parameter
     */
    public initCamera(fieldOfView, aspectRatio, nearClippingPane, farClippingPane, cameraZ) {
        this.camera = new PerspectiveCamera(fieldOfView,
            aspectRatio,
            nearClippingPane,
            farClippingPane);
        this.camera.position.z = 0.1;
        this.setQuaternionDefault();
        // this.camera.updateProjectionMatrix();
        // this.resetViewOffset();
    }

    /**
     * sets view offsets of camera
     * @param x: offset in x direction
     * @param y: offset in y direction
     */
    public setViewOffset(x: number, y: number) {
        const width = this.camera.getFilmWidth();
        const height = this.camera.getFilmHeight();
        this.camera.setViewOffset(width, height, x, y, width, height);
        this._viewOffsetX = x;
        this._viewOffsetY = y;
    }

    /**
     * sets the view offset in both directions to 0
     */
    public resetViewOffset() {
        this.setViewOffset(0, 0);
        this.camera.updateMatrix();
    }

    /**
     * rotates camera up by applying given matrix
     * @param rotation
     */
    public rotateCameraUp(rotation: Matrix4) {
        this.setQuaternionDefault();

        // get new camera rotation axis:
        // rotate up vector by rotation matrix
        const cameraUp = new Object3D();
        cameraUp.position.copy(Object3D.DefaultUp);
        cameraUp.applyMatrix4(rotation);
        cameraUp.updateMatrix();

        this.camera.up.set(cameraUp.position.x, cameraUp.position.y, cameraUp.position.z);
        this.camera.up.set(cameraUp.position.x, cameraUp.position.y, cameraUp.position.z);
    }

    /**
     * resets the rotation of the camera up vector
     */
    public resetUpRotation() {
        // this.camera.quaternion.copy(this.quaternionDefault);
        this._defaultQuaternion = new Quaternion();
        this.camera.up.copy(Object3D.DefaultUp);
        this._previousRotation = this.camera.rotation.toVector3();
    }

    public setPreviousRotation() {
        this._previousRotation = this.camera.rotation.clone().toVector3();
    }

    // -------------------------------------------------------------------------------------------------------------------------------------

    /**
     * saves current camera quaternion as default state
     */
    private setQuaternionDefault() {
        this._defaultQuaternion = this.camera.quaternion.clone();
    }

}
